import React from 'react';
import { Dialog, Button, Stack, Typography, Box } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

interface UnsavedChangesModalProps {
  open: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  open,
  onSave,
  onDiscard,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
    >
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <WarningIcon className="text-yellow-500" />
          <Typography variant="h6" className="text-yellow-500">Unsaved Changes</Typography>
        </Box>
        
        <Typography variant="body1" sx={{ mb: 3 }}>
          You have unsaved changes. What would you like to do?
        </Typography>
        
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Stack direction="row" spacing={1}>
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="outlined" color="error" onClick={onDiscard}>
              Discard Changes
            </Button>
            <Button variant="contained" onClick={onSave}>
              Save Changes
            </Button>
          </Stack>
        </Box>
      </Box>
    </Dialog>
  );
};

export default UnsavedChangesModal;